import { styled } from '@mui/material/styles';
import { Pagination } from 'react-admin';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

const columnStyle115 = getColumnStyle(115);

export const StyledDatagrid = styled(DatagridConfigurableWithStickyActions)({
  '& .column-id': { width: 0 },
  '& .column-active': { ...getColumnStyle(68), textAlign: 'center' },
  '& .column-provider': { ...getColumnStyle(86), textAlign: 'center' },
  '& .column-credentials': { width: 0, textWrap: 'nowrap' },
  '& .column-createdAt': columnStyle115,
  '& .column-updatedAt': columnStyle115,
});

export const StyledPagination = styled(Pagination)({
  display: 'block',
  marginBottom: '24px',
  backgroundColor: 'red',
});
